var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-modal-layout',{ref:"modal",attrs:{"size":"xl","title":_vm.getMessage_(_vm.screen.menuTitle),"show":_vm.show_,"closeModal":_vm.closeModal}},[_c('comm-cd-desc-table',{attrs:{"scrId":_vm.scrId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }